/** @format */

import React from "react";

export default () => (
  <svg
    style={{
      background: "#332f2f",
      borderRadius: "8px",
      opacity: "0.8",
    }}
    width="30"
    height="31"
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.0742188"
      width="60"
      height="60"
      rx="15"
      fill="#FBFBFB"
      fillOpacity="0.15"
    />
    <path
      d="M33.5352 26.6099L26.4641 33.6809"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.4648 26.6099L33.5359 33.6809"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
